import { Navigate } from "react-router";

const base_url = process.env.REACT_APP_BASE_URL

export const OnlinePrivateRoutes = ({children}) => {
    const getTokenFromLocalStorage = JSON.parse(localStorage.getItem("token"));
    const isOnlineStudent = JSON.parse(localStorage.getItem("participation_type")) === "Online";
    
    // If not logged in, redirect to login
    if (getTokenFromLocalStorage === null) {
        return <Navigate to={`${base_url}/login`} replace="true" />;
    }
    
    // If not an online student, redirect to regular home
    if (!isOnlineStudent) {
        return <Navigate to={`${base_url}/`} replace="true" />;
    }
    
    // If logged in and is an online student, show the children
    return children;
} 